import { connect } from 'react-redux';

import { track } from '@ha/analytics';

import { send as showAlert } from 'ha/modules/Alertbar/actions';

import { SocialShare } from '../components/SocialShare';

const SocialShareContainer = connect(null, {
  track,
  showAlert,
})(SocialShare);
export { SocialShareContainer };
